export const SECRETARY_STAMP = "NOT A CHATBOT — A TEAM MEMBER";

export const SECRETARY_SCAN_LINE = "Knows your business · Books inspections · No new admin hire";

export const SECRETARY_HEADLINE = {
  lead: "It's the",
  accent: "AI Employee",
  tail: "Your Roofing Business Has Been Missing.",
};

export const SECRETARY_SUBHEAD =
  "Homeowners don't want phone trees or robotic scripts. They want someone who knows your services, pricing, and schedule — and actually books the job.";

export const SECRETARY_REJECTED = {
  label: "CHATBOT",
  items: [
    '"Press 1 for sales, 2 for support"',
    "Generic scripts that frustrate leads",
    "Collects info — then nothing happens",
  ],
};

export const SECRETARY_HIRED = {
  label: "AI EMPLOYEE",
  items: [
    "Greets leads like your best office manager",
    "Knows pricing, service area, and policies",
    "Books inspections and updates your calendar",
  ],
};

export const SECRETARY_CAPABILITIES = [
  {
    id: "pricing",
    tag: "01",
    value: "PRICING",
    label: "Knows your price list",
    detail: "Checks rates before every reply — like a trained estimator",
  },
  {
    id: "weather",
    tag: "02",
    value: "WEATHER",
    label: "Thinks ahead",
    detail: "Won't book inspections on storm days",
    highlight: true,
  },
  {
    id: "calendar",
    tag: "03",
    value: "CALENDAR",
    label: "Fills your schedule",
    detail: "Finds open slots — no back-and-forth",
  },
];

export const SECRETARY_WORKFLOW = [
  { step: "MESSAGE", text: "Customer texts on WhatsApp" },
  { step: "QUALIFY", text: "AI employee vets the job" },
  { step: "BOOKED", text: "You wake up to a booked inspection" },
];

export const SECRETARY_PAYOFF = {
  lead: "You don't need another office admin or new software.",
  channels: "WhatsApp · Telegram · Website — same channels your team already uses.",
};

export const SOFT_CTA = "Meet your AI employee — free demo";
